import { render, staticRenderFns } from "./view01.vue?vue&type=template&id=b526bae0&scoped=true"
import script from "./view01.vue?vue&type=script&lang=js"
export * from "./view01.vue?vue&type=script&lang=js"
import style0 from "./view01.vue?vue&type=style&index=0&id=b526bae0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b526bae0",
  null
  
)

export default component.exports